// project imports
import { Theme } from '@mui/material/styles';
import './DefaultTheme';

const components: any = (theme: Theme) => {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
        '.MuiPickersDay-root': {
          '&:hover': {
            background: `${theme.custom.color.blueberry} !important`,
            color: '#FFFFFF !important',
          },
          '&:active': {
            background: `${theme.custom.color.blueberry} !important`,
            color: '#FFFFFF !important',
          },
        },
        '& .MuiPickersDay-root[aria-selected="true"]': {
          background: `${theme.custom.color.blueberry} !important`,
          color: '#FFFFFF !important',
        },
        '& .MuiPickersDay-root.Mui-selected': {
          background: `${theme.custom.color.blueberry} !important`,
          color: '#FFFFFF !important',
          '&:hover, &:focus': {
            background: `${theme.custom.color.blueberry} !important`,
          },
        },
        '& .MuiMonthCalendar-button.Mui-selected': {
          backgroundColor: `${theme.custom.color.blueberry} !important`,
          color: '#FFFFFF !important',
        },
        '& .MuiMonthCalendar-button:hover, & .MuiMonthCalendar-button:active': {
          backgroundColor: `${theme.custom.color.blueberry} !important`,
          color: '#FFFFFF !important',
        },
        '& .MuiYearCalendar-button.Mui-selected': {
          backgroundColor: `${theme.custom.color.blueberry} !important`,
          color: '#FFFFFF !important',
        },
        '& .MuiYearCalendar-button:hover, & .MuiYearCalendar-button:active': {
          backgroundColor: `${theme.custom.color.blueberry} !important`,
          color: '#FFFFFF !important',
        },
        '& .MuiPickersDay-today': {
          borderColor: `${theme.custom.color.blueberry} !important`,
        },
        '& .MuiPickersTextField-root .MuiOutlinedInput-notchedOutline': {
          borderColor: '#939397 !important',
        },
        '& .MuiPickersTextField-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
          borderColor: '#939397 !important',
        },
        '& .MuiPickersTextField-root .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#939397 !important',
        },
        '& .MuiPickersTextField-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#939397 !important',
        },
        '& .MuiPickersOutlinedInput-root .MuiPickersOutlinedInput-notchedOutline': {
          borderColor: '#939397 !important',
        },
        '& .MuiPickersOutlinedInput-root:hover .MuiPickersOutlinedInput-notchedOutline': {
          borderColor: '#939397 !important',
        },
        '& .MuiPickersOutlinedInput-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline': {
          borderColor: '#939397 !important',
        },
        '& .MuiPickersLayout-root .MuiDivider-root, & .MuiPickersLayout-root .MuiPickersLayout-contentWrapper': {
          borderColor: '#939397 !important',
        },
        '& .rs-calendar-table-cell-is-today .rs-calendar-table-cell-content': {
          WebkitBoxShadow: `inset 0 0 0 1px ${theme.custom.color.blueberry} !important`,
        },
        '& .rs-calendar-table-cell': {
          '&:hover': {
            '& .rs-calendar-table-cell-content': {
              background: `${theme.custom.color.blueberry} !important`,
              color: '#FFFFFF !important',
            },
          },
        },
        '& .rs-calendar-table-cell-selected .rs-calendar-table-cell-content': {
          background: `${theme.custom.color.blueberry} !important`,
          color: '#FFFFFF !important',
        },
        '& .rs-calendar-table-cell-in-range': {
          '&::before': {
            background: 'rgba(172, 177, 255, 0.22) !important',
          },
        },
        '& .rs-calendar-table-cell-in-range .rs-calendar-table-cell-content': {
          color: '#28272F !important',
        },
        '& .rs-btn-primary': {
          background: '#ACB1FF !important',
          color: '#28272F !important',
          '&:hover': {
            background: '#BCC1FF !important',
            color: '#28272F !important',
          },
        },
        '& .rs-picker-toggle-value': {
          color: '#28272F !important',
        },
        '& .rs-picker-toggle': {
          borderColor: '#939397 !important',
        },
        '& .rs-picker-toggle-caret': {
          color: '#6F6F8F',
        },
        html: {
          height: '100%',
          width: '100%',
        },
        a: {
          textDecoration: 'none',
        },
        body: {
          height: '100%',
          margin: 0,
          padding: 0,
        },
        '#root': {
          height: '100%',
        },
        "*[dir='rtl'] .buyNowImg": {
          transform: 'scaleX(-1)',
        },
        '.border-none': {
          border: '0px',
          td: {
            border: '0px',
          },
        },
        '.btn-xs': {
          minWidth: '30px !important',
          width: '30px',
          height: '30px',
          borderRadius: '6px !important',
          padding: '0px !important',
        },
        '.hover-text-primary:hover .text-hover': {
          color: theme.palette.primary.main,
        },
        '.hoverCard:hover': {
          scale: '1.01',
          transition: ' 0.1s ease-in',
        },
        '.signup-bg': {
          position: 'absolute',
          top: 0,
          right: 0,
          height: '100%',
        },
        '.MuiBox-root': {
          borderRadius: theme.shape.borderRadius,
        },
        '.MuiCardHeader-action': {
          alignSelf: 'center !important',
        },
        '.emoji-picker-react .emoji-scroll-wrapper': {
          overflowX: 'hidden',
        },
        '.scrollbar-container': {
          borderRight: '0 !important',
        },
        '.theme-timeline .MuiTimelineOppositeContent-root': {
          minWidth: '90px',
        },
        '.MuiAlert-root .MuiAlert-icon': {
          color: 'inherit!important',
        },
        '.MuiTimelineConnector-root': {
          width: '1px !important',
        },
        ' .simplebar-scrollbar:before': {
          background: `${theme.palette.grey[300]} !important`,
        },
        '@keyframes gradient': {
          '0%': {
            backgroundPosition: '0% 50%',
          },
          '50%': {
            backgroundPosition: ' 100% 50%',
          },
          '100% ': {
            backgroundPosition: ' 0% 50%',
          },
        },
        '@keyframes slide': {
          '0%': {
            transform: 'translate3d(0, 0, 0)',
          },
          '100% ': {
            transform: 'translate3d(-2086px, 0, 0)',
          },
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&:hover, &:active': {
            backgroundColor: `${theme.custom.color.blueberry} !important`,
            color: '#FFFFFF !important',
          },
          '&.Mui-selected': {
            backgroundColor: `${theme.custom.color.blueberry} !important`,
            color: '#FFFFFF !important',
            '&:hover, &:focus': {
              backgroundColor: `${theme.custom.color.blueberry} !important`,
            },
          },
        },
      },
    },
    MuiMonthCalendar: {
      styleOverrides: {
        button: {
          '&:hover, &:active': {
            backgroundColor: `${theme.custom.color.blueberry} !important`,
            color: '#FFFFFF !important',
          },
          '&.Mui-selected': {
            backgroundColor: `${theme.custom.color.blueberry} !important`,
            color: '#FFFFFF !important',
            '&:hover, &:focus': {
              backgroundColor: `${theme.custom.color.blueberry} !important`,
            },
          },
        },
      },
    },
    MuiYearCalendar: {
      styleOverrides: {
        button: {
          '&:hover, &:active': {
            backgroundColor: `${theme.custom.color.blueberry} !important`,
            color: '#FFFFFF !important',
          },
          '&.Mui-selected': {
            backgroundColor: `${theme.custom.color.blueberry} !important`,
            color: '#FFFFFF !important',
            '&:hover, &:focus': {
              backgroundColor: `${theme.custom.color.blueberry} !important`,
            },
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          ':before': {
            backgroundColor: theme.palette.grey[100],
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // border: `1px solid ${theme.palette.divider}`,
          backgroundImage: 'none',
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
        },
      },
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
        sizeSmall: {
          width: 30,
          height: 30,
          minHeight: 30,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          boxShadow: 'none',
          '&:disabled': {
            background: '#d1d1d1',
            color: '#FFFFFF',
          },
        },
        text: {
          padding: '5px 15px',
          color: 'white',
        },
        textPrimary: {
          backgroundColor: '#F85E1D',
          '&:hover': {
            backgroundColor: '#f17743',
            color: 'white',
          },
        },
        textSecondary: {
          background: '#C5E2E0',
          color: '#155C7E',
          '&:hover': {
            backgroundColor: '#abcfcc',
          },
        },
        containedPrimary: {
          backgroundColor: '#ACB1FF',
          '&:hover': {
            backgroundColor: '#BCC1FF',
            color: 'white',
          },
        },
        containedError: {
          backgroundColor: '#f85e1d !important',
          '&:hover': {
            backgroundColor: '#932c1d !important',
            color: 'white',
          },
        },
        textSuccess: {
          backgroundColor: theme.palette.success.light,
          '&:hover': {
            backgroundColor: theme.palette.success.main,
            color: 'white',
          },
        },
        textError: {
          backgroundColor: '#f85e1d !important',
          '&:hover': {
            backgroundColor: '#932c1d !important',
            color: 'white',
          },
          '&:disabled': {
            backgroundColor: '#d1d1d1 !important',
            color: 'white',
          },
        },
        textInfo: {
          backgroundColor: '#ACB1FF',
          color: '#28272F',
          '&:hover': {
            backgroundColor: '#BCC1FF',
          },
        },
        textWarning: {
          backgroundColor: theme.palette.warning.light,
          '&:hover': {
            backgroundColor: theme.palette.warning.main,
            color: 'white',
          },
        },
        outlinedPrimary: {
          '&:hover': {
            backgroundColor: theme.palette.primary.main,
          },
        },
        outlinedSecondary: {
          '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: 'white',
          },
        },
        outlinedError: {
          '&:hover': {
            backgroundColor: theme.palette.error.main,
            color: 'white',
          },
        },
        outlinedSuccess: {
          '&:hover': {
            backgroundColor: theme.palette.success.main,
            color: 'white',
          },
        },
        outlinedInfo: {
          '&:hover': {
            backgroundColor: theme.palette.info.main,
            color: 'white',
          },
        },
        outlinedWarning: {
          '&:hover': {
            backgroundColor: theme.palette.warning.main,
            color: 'white',
          },
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: '16px 24px',
        },
        title: {
          fontSize: '1.125rem',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          width: '100%',
          padding: '15px',
          backgroundImage: 'none',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '24px',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child td': {
            borderBottom: 0,
          },
        },
      },
    },
    MuiGridItem: {
      styleOverrides: {
        root: {
          paddingTop: '30px',
          paddingLeft: '30px !important',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          background: 'white',
        },
        row: {
          background: '#FAF3F1',
          '&:hover': {
            background: '#DDB288 !important',
          },
          '& svg': {
            color: '#6F6F8F',
          },
        },
        columnHeaderRow: {
          '& svg': {
            color: '#6F6F8F',
          },
        },
        selected: {
          background: 'red',
        },
      },
      MuiCheckbox: { root: { color: 'red' } },
    },
    MuiTablePagination: {
      styleOverrides: {
        menuItem: {
          fontWeight: 600,
        },
      },
    },
    MuiTypography: {
      root: {
        color: 'red',
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.grey[200],
          borderRadius: '6px',
        },
      },
    },
    MuiTimelineConnector: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.divider,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
        },
      },
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '0.75rem',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        filledSuccess: {
          color: 'white',
        },
        filledInfo: {
          color: 'white',
        },
        filledError: {
          color: 'white',
        },
        filledWarning: {
          color: 'white',
        },
        standardSuccess: {
          backgroundColor: theme.palette.success.light,
          color: theme.palette.success.main,
        },
        standardError: {
          backgroundColor: theme.palette.error.light,
          color: theme.palette.error.main,
        },
        standardWarning: {
          backgroundColor: theme.palette.warning.light,
          color: theme.palette.warning.main,
        },
        standardInfo: {
          backgroundColor: theme.palette.info.light,
          color: theme.palette.info.main,
        },
        outlinedSuccess: {
          borderColor: theme.palette.success.main,
          color: theme.palette.success.main,
        },
        outlinedWarning: {
          borderColor: theme.palette.warning.main,
          color: theme.palette.warning.main,
        },
        outlinedError: {
          borderColor: theme.palette.error.main,
          color: theme.palette.error.main,
        },
        outlinedInfo: {
          borderColor: theme.palette.info.main,
          color: theme.palette.info.main,
        },
        successIcon: {
          color: theme.palette.info.main,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#6F6F8F',
          },

          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#6F6F8F',
            },
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey[300],
          },
        },

        // input: {
        //   padding: '12px 14px',
        // },
        // inputSizeSmall: {
        //   padding: '8px 14px',
        // },
      },
    },
    MuiPickersOutlinedInput: {
      styleOverrides: {
        root: {
          '& .MuiPickersOutlinedInput-notchedOutline': {
            borderColor: '#939397 !important',
          },
          '&:hover .MuiPickersOutlinedInput-notchedOutline': {
            borderColor: '#939397 !important',
          },
          '&.Mui-focused .MuiPickersOutlinedInput-notchedOutline': {
            borderColor: '#939397 !important',
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: theme.palette.background.paper,
          background: theme.palette.text.primary,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderColor: `${theme.palette.divider}`,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.25rem',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          boxShadow: 'rgb(145 158 171 / 30%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px',
        },
      },
    },
  };
};
export default components;
